import { Injectable } from '@angular/core';
import { SelectionModel, SelectionChange } from '@angular/cdk/collections';
import { Customer } from './customer-common';

@Injectable()
export class CustomerSelectionService {
  private readonly selectedCustomers: SelectionModel<Customer> = new SelectionModel<Customer>(true, []);

  constructor() {
    this.selectedCustomers.changed.subscribe((selectionChange: SelectionChange<Customer>) => {
      selectionChange.added.forEach((selectionAdded) => {
        if (
          this.selectedCustomers.selected.filter(
            (selectedCustomer) => selectionAdded.contactId === selectedCustomer.contactId,
          ).length > 1
        ) {
          this.deselect(selectionAdded);
        }
      });
    });
  }

  public isCustomerSelected(customer: Customer): boolean {
    return (
      this.selectedCustomers.selected.filter((selectedCustomer) => customer.contactId === selectedCustomer.contactId)
        .length !== 0
    );
  }

  public select(customer: Customer): void {
    if (!this.isCustomerSelected(customer)) {
      this.selectedCustomers.select(customer);
    }
  }

  public deselect(customer: Customer): void {
    this.selectedCustomers.selected.forEach((selected) => {
      if (selected.contactId === customer.contactId) {
        this.selectedCustomers.deselect(selected);
      }
    });
  }

  public bulkSelect(customers: Customer[]): void {
    this.clearSelection();
    this.selectedCustomers.select(...customers);
  }

  public toggle(customer: Customer): void {
    this.selectedCustomers.toggle(customer);
  }

  public clearSelection(): void {
    this.selectedCustomers.clear();
  }

  public nbSelected(): number {
    return this.selectedCustomers.selected.length;
  }

  public nbSelectedWithEmail(): number {
    return this.selectedCustomers.selected.filter((customer) => !!customer.email).length;
  }

  public nbSelectedWithPhone(): number {
    return this.selectedCustomers.selected.filter((customer) => !!customer.phone).length;
  }

  public getSelectedCustomerIds(): string[] {
    return this.selectedCustomers.selected.map((customer) => customer.contactId);
  }

  public getSelectedCustomers(): Customer[] {
    return this.selectedCustomers.selected;
  }

  public getSelectedCustomersWithEmail(): Customer[] {
    return this.selectedCustomers.selected.filter((customer) => !!customer.email);
  }

  public getSelectedCustomersWithPhone(): Customer[] {
    return this.selectedCustomers.selected.filter((customer) => !!customer.phone);
  }
}
